import Types from "./Types";

const INITIAL_STATE = {
  chapters: [],
  chapter: {},
  isLoading: false,
  count: "",
};

export default function superadminChapters(state = INITIAL_STATE, action) {
  const { type, payload } = action;
  switch (type) {
    case Types.GET_SUPERADMIN_CHAPTERS_SUCCESS: {
      return {
        ...state,
        chapters: payload.data,
        count: payload.data.length,
      };
    }

    case Types.GET_SUPERADMIN_CHAPTER_SUCCESS: {
      return {
        ...state,
        chapter: payload,
      };
    }

    case Types.EDIT_SUPERADMIN_CHAPTER_SUCCESS: {
      let data = payload.data;
      const chapters = state.chapters;
      let idx = 0;
      chapters.forEach((table, index) => {
        if (table.id === data.id) {
          idx = index;
          return;
        }
      });

      chapters[idx] = data;
      return {
        ...state,
        chapters: chapters,
      };
    }

    case Types.RESTRICT_SUPERADMIN_CHAPTER_SUCCESS: {
      let data = payload.data;
      const chapters = state.chapters;
      let idx = 0;
      chapters.forEach((table, index) => {
        if (table.id === data.id) {
          idx = index;
          return;
        }
      });

      chapters[idx] = data;
      return {
        ...state,
        chapters: chapters,
      };
    }
    case Types.ASQUARA_SUPERADMIN_CHAPTER_SUCCESS: {
      let data = payload.data;
      const chapters = state.chapters;
      let idx = 0;
      chapters.forEach((table, index) => {
        if (table.id === data.id) {
          idx = index;
          return;
        }
      });

      chapters[idx] = data;
      return {
        ...state,
        chapters: chapters,
      };
    }

    case Types.ACTIVE_SUPERADMIN_CHAPTER_SUCCESS: {
      let data = payload.data;
      const chapters = state.chapters;
      let idx = 0;
      chapters.forEach((table, index) => {
        if (table.id === data.id) {
          idx = index;
          return;
        }
      });

      chapters[idx] = data;
      return {
        ...state,
        chapters: chapters,
      };
    }

    // create
    case Types.CREATE_SUPERADMIN_CHAPTER_SUCCESS: {
      const data = payload.data.data;
      let newArray = state.chapters.slice();
      let index = state.chapters.length + 1;
      newArray.splice(index, 0, data);
      return {
        ...state,
        chapters: newArray,
        count: state.count + 1,
      };
    }
    case Types.ADD_SUPERADMIN_CHAPTERS_LOADING: {
      return {
        ...state,
        isLoading: payload,
      };
    }

    case Types.DELETE_SUPERADMIN_CHAPTER_SUCCESS: {
      const newchapters = state.chapters.filter((item) => item.id !== payload);
      return {
        ...state,
        chapters: newchapters,
        count: state.count - 1,
      };
    }
    default: {
      return state;
    }
  }
}
